import type { Logger } from '@devhacker/shared/libs/logger';
import { parseData } from '@devhacker/shared/utils/parseData';
import { API_URL, API_TIMEOUT } from '~/constants/config';
import type { IAskQuestion } from '~/types/api/askQuestion';
import { askQuestionSchema } from '~/schemas/askQuestionSchema';
import { createAxiosLikeFetch } from '@devhacker/shared/libs/fetch/createAxiosLikeFetch';
import { createLoggerInterceptors } from '@devhacker/shared/libs/logger';

type Params = {
  $logger: Logger;
};

export default ({ $logger }: Params): IAskQuestion => {
  const askQuestionFetch = createAxiosLikeFetch({
    baseURL: API_URL,
    timeout: API_TIMEOUT,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    ...createLoggerInterceptors($logger, 'ask-question'),
  });

  return {
    async askQuestion(id, name, question) {
      const formData = new FormData();
      formData.append('id', id);
      formData.append('name', name);
      formData.append('question', question);
      const url = '/wp-admin/admin-ajax.php?action=ask-question';
      const { data } = await askQuestionFetch(url, { method: 'POST', body: formData });
      return parseData(data, askQuestionSchema);
    },
  };
};
